import React from 'react';
import { BasePreferences } from '../model/types';
import PreferencesAudioControl from './preferencesAudioControl';

function SoundControl() {
  const soundControlList: { title: string; key: keyof BasePreferences }[] = [
    { title: 'sound_on_your_move', key: 'SOUND_ON_YOUR_MOVE' },
    { title: 'sound_on_opponent_move', key: 'SOUND_ON_OPPONENT_MOVE' },
    {
      title: 'sound_on_joining_your_table',
      key: 'SOUND_ON_JOINING_YOUR_TABLE',
    },
    { title: 'sound_on_invitation', key: 'SOUND_ON_INVITATION' },
  ];

  return <PreferencesAudioControl>{soundControlList}</PreferencesAudioControl>;
}

export default SoundControl;
